// @flow

import * as React from "react";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import getSessionToken from "../../utils/getSessionToken";
type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const PreferencesForm = (props: PropsType): React.Node => {
    // const [setFetching] = React.useState(false);

    const handleFormSuccess = (formData, fields) => {
        // prepare post body object using arrays for each group/area
        const postBody = {};
        fields.forEach(field => {
            if (field.value && field.group) {
                if (!postBody[field.group]) {
                    postBody[field.group] = [];
                }
                postBody[field.group].push(field.name);
            }
        });

        // submit the form to the endpoint
        // setFetching(true);
        getSessionToken().then(token => {
            fetch(props.endpoint, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-Token": token,
                },
                method: "POST",
                body: JSON.stringify(postBody),
            })
                .then((response): any => response.json())
                .then(data => {
                    // setFetching(false);

                    // find form wrapper to replace
                    const formWrapper = document.querySelector(
                        `[data-react-form="${props.id}"]`
                    );

                    // put return markup at formWrapper
                    formWrapper.insertAdjacentHTML("afterend", data.markup);

                    // remove formWrapper
                    formWrapper.remove();

                    // enable preferences link
                    const preferencesLink = document.querySelector(
                        "[data-preferences-link]"
                    );
                    if (preferencesLink) {
                        preferencesLink.classList.remove("hidden");
                        window.dispatchEvent(new Event("resize"));
                    }
                })
                .catch(res => {
                    // setFetching(false);
                    console.error(res);
                });
        });
    };

    if (!props.area) {
        return null;
    }

    return (
        <ReactForm
            onSuccess={handleFormSuccess}
            className="react-form--preferences"
        >
            {/* {fetching ? "Loading..." : ""} */}

            <div className="row">
                <div className="react-form--preferences__info col-xs-12 col-md-4">
                    <div className="heading-3">
                        {props.title || "Select your interests"}
                    </div>
                    <p>
                        We use this information to provide you with content
                        based on your topics of interest.
                    </p>
                </div>

                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        {props.area.map((area, index): any => {
                            return (
                                <div key={index} className="col-xs-12 col-md-6">
                                    <div className="heading-5">
                                        {area.title}
                                    </div>

                                    <div className="react-form__group">
                                        {area.preferences.map(
                                            (preference, index): any => {
                                                return (
                                                    <ReactFormField
                                                        key={index}
                                                        type="checkbox"
                                                        label={preference.label}
                                                        name={preference.name}
                                                        group={area.key}
                                                        // value="1"
                                                    />
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="row row--no-margin end-xs">
                <div className="col-xs-12 col-md-4">
                    <button type="submit" className="button button--wide">
                        Save
                    </button>
                </div>
            </div>

            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default PreferencesForm;
